import { colors } from '@amazd/common/static';
import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  title: {
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '24px',
    color: colors.black,
  },
  subtitle: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: colors.grey70,
  },
}));
